export interface SpecificTableData {
    list: [];
    currentPage: null;
    totalPages: null;
    totalNumberOfResults: null;
}

export interface FetchAutoCompleteDataQuery {
    resourceFetchPath: string;
    query: string;
    dataMapperKey?: string;
}

export interface FetchDataQuery {
    resourceFetchPath: string;
    query: string;
    dataMapperKey: string;
}

export interface UpdateDataQuery {
    url: string;
    method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
    body?: object | Array<unknown> | null;
    downloadFileName?: string;
}

export enum TableColumnWidth {
    EXTRA_SMALL = "50px",
    SMALL = "150px",
    MEDIUM = "250px",
    LARGE = "500px",
}

export enum Actions {
    ADD,
    DELETE,
    COPY,
    FORM_COPY,
}

export type CellValue = string | number | boolean | null;
